import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { FocusSelectOnDirective } from '../../../directives/focus-select.directive';
import { SanitizeCharsDirective } from '../../../directives/sanitize-chars.directive';
import { LetterCellEditorBaseComponent } from '../letter-cell-editor-base/letter-cell-editor-base.component';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'se-letter-cell-editor-popup',
    templateUrl: './letter-cell-editor-popup.component.html',
    styleUrls: ['./letter-cell-editor-popup.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
        FocusSelectOnDirective,
        SanitizeCharsDirective,
        TranslateModule,
    ],
})
export class LetterCellEditorPopupComponent extends LetterCellEditorBaseComponent {
    readonly width = input.required<string>();
}
